import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { getUserRequest, getUsersRequest, updateUserTerritoryRequest } from '../api/userApi'
import { getUserAction, getUsersAction, updateUsersTerritoryAction } from '../redux/actions/userActions'
import { keycloakUpdateToken } from '../services/keycloak.service'

export const useUserApi = () => {
  const dispatch = useDispatch()

  const getUsers = useCallback(async () => {
    await getUsersRequest()
      .then(response => {
        dispatch(getUsersAction(response.data))
      })
      .catch(error => {
        console.error(error)
      })
  }, [])

  const getUser = useCallback(async (userId: string) => {
    await getUserRequest(userId)
      .then(response => {
        dispatch(getUserAction(response.data))
      })
      .catch(error => {
        console.error(error)
      })
  }, [])

  const updateUserTerritory = useCallback(async (territoryId: number, userId: string) => {
    await updateUserTerritoryRequest(territoryId)
      .then(response => {
        dispatch(updateUsersTerritoryAction(response.data))
        keycloakUpdateToken()
        getUser(userId)
      })
      .catch(error => {
        console.error(error)
      })
  }, [])

    const updateUserTerritorySync =  (territoryId: number, userId: string) => {
      updateUserTerritoryRequest(territoryId)
      .then(response => {
        dispatch(updateUsersTerritoryAction(response.data))

        getUserRequest(userId)
        .then(response => {
          dispatch(getUserAction(response.data))
          keycloakUpdateToken()
        })
        .catch(error => {
          console.error(error)
        })
      })
      .catch(error => {
        console.error(error)
      })
    }

  return {
    getUsers,
    getUser,
    updateUserTerritory,
    updateUserTerritorySync,
  }
}
